import React,{useState}from "react";
import { Flex, Box } from 'reflexbox';
import Typography from "ui-components/lib/components/Typography";
import Modal from 'ui-components/lib/components/Modal'
import useModal from 'ui-components/lib/hooks/useModal'
import {useQuery} from "@apollo/react-hooks";
import {demandsQueries,documentsQueries, walletQueries} from "../../graphql/queries";
import { Markup } from 'interweave';
import './ClientDemandPanel.css'
import ModernChart from "./ModernChart";
import ModernCard from "./ModernCard";
import Spinner from "ui-components/lib/components/Spinner";
import { 
  AlertCircle, 
  Clock, 
  PlayCircle, 
  PauseCircle, 
  CheckCircle2, 
  XCircle, 
  FileText, 
  DollarSign,
  FileCheck,
  FileQuestion,
  Send,
  Eye,
  Wallet
} from 'lucide-react';


const ClientDemandsPanel = () => {
  let loading = true;

  const [period,setPeriod] = useState("last_30_days")

  //Quering demands
  let demands = {
    pendingDemands:[],
    inProgressDemands:[],
    standbyDemands:[],
    waitingApprovalDemands:[],
    inEstimatingDemands:[],
    draftDemands:[],
    demandSentDemands:[],
    inReviewDemands:[],
    canceledDemands:[],
    doneDemands:[],
    waitingEstimateApprovalDemands:[],
    waitingLawyerAcceptanceDemands:[],
    clientPendencices:[],
    statuses:[
      'Pendente',
      'Em progresso',
      'Standby',
      'Aguardando aprovação',      
      'Aguardando Orçamento',
      'Pendente de informação',
      'Demanda Enviada',
      'Aguardando revisão',
      'Cancelado',
      'Concluído',
      'Aguardando aprovação de orçamento',
      'Aguardando aceite do advogado'
    ]
  }

  const { data: demandsData, error: demandsError } = useQuery(demandsQueries.GET_DEMANDS, {
    variables: {
      queryBy: 'status',
      offset:999999
    },
    errorPolicy: 'all',
    onError: (error) => {
      console.error('Error fetching demands:', error)
    }
  })

  let demandsToFilter = demandsData?.listDemands?.data;

  if(demandsToFilter !== undefined){
    demandsToFilter.filter((demand)=>{
        if(demand.status === 'pending'){
          demand.statuses = 'Pendente';
          demands.pendingDemands.push(demand)
        }
        if(demand.status === 'in_progress'){
            demand.statuses = 'Em Progresso';
            demands.inProgressDemands.push(demand)
        }
        if(demand.status === 'standby'){
          demand.statuses = 'Standby';
          demands.standbyDemands.push(demand)
        }
        if(demand.status === 'waiting_approval'){
          demand.statuses = 'Aguardando Aprovação';
          demands.waitingApprovalDemands.push(demand)
        }
        if(demand.status === 'in_estimating'){
          demand.statuses = 'Aguardando Orçamento';
          demands.inEstimatingDemands.push(demand)
        }
        if(demand.status === 'draft'){
          demand.statuses = 'Pendente de Informação';
          demands.draftDemands.push(demand)
        }
        if(demand.status === 'demand_sent'){
          demand.statuses = 'Demanda Enviada';
          demands.demandSentDemands.push(demand)
        }
        if(demand.status === 'in_review'){
          demand.statuses = 'Aguardando Revisão';
          demands.inReviewDemands.push(demand)
        }
        if(demand.status === 'canceled'){
          demand.statuses = 'Cancelado';
          demands.canceledDemands.push(demand)
        }
        if(demand.status === 'done'){
          demand.statuses = 'Concluído';
          demands.doneDemands.push(demand)
        }
        if(demand.status === 'waiting_estimate_approval'){
          demand.statuses = 'Aguardando Aprovação de Orçamento';
          demands.waitingEstimateApprovalDemands.push(demand)
        }
        if(demand.status === 'waiting_lawyer_acceptance'){
          demand.statuses = 'Aguardando Aceite do Advogado';
          demands.waitingLawyerAcceptanceDemands.push(demand)
        }
        return true
    });
    loading = false
  }

  //Quering documents
  let documents = {
    folderIds:[],
    folderNames:[],
    numberOfDocsInFolders:[]
  }

  const { data: documentsData, error: documentsError } = useQuery(documentsQueries.GET_DOCUMENTS,{
    variables: {
      queryBy: 'status',
      offset:999999
    },
    errorPolicy: 'all',
    onError: (error) => {
      console.error('Error fetching documents:', error)
    }
  })

  let foldersAndFilesToFilter = documentsData?.repositories?.folders;

  if(foldersAndFilesToFilter !== undefined){
    foldersAndFilesToFilter.filter((folderAndFile)=> {
        documents.folderIds.push(folderAndFile._id)
        documents.folderNames.push(folderAndFile.name);
        documents.numberOfDocsInFolders.push(folderAndFile.numberOfDocs)
        return true;
    })
  }

  let transactions = {
    type:[],
    date:[],
    description:[],
    valueReserve:[],
    valueDebit:[],
    valueCredit:[],
    totalExpended:0.0
  }


  const { data: walletData, error: walletError, refetch: refetchMyStatements } = useQuery(walletQueries.GET_MY_STATEMENTS, {
    variables: {
      queryBy: 'type',
      offset:999999,
      filterPeriod:period
    },
    errorPolicy: 'all',
    onError: (error) => {
      console.error('Error fetching wallet statements:', error)
    }
  })

  const { data: bonuzSubData, loading: loadingBonuzSub, error: subscriptionError } = useQuery(walletQueries.GET_MY_SUBSCRIPTION, {
    variables: {
      subscriptionType: 'planos-bonuz',
      planIdentifier: 'bonuz-plans',
    },
    errorPolicy: 'all',
    onError: (error) => {
      console.error('Error fetching subscription:', error)
    }
  })
  const bonuzActive = bonuzSubData?.subscription?.active === true

  function changePeriod(periodToChange){
      setPeriod(periodToChange)
  }

  let transactionsToFilter = walletData?.statements?.data;

  if(transactionsToFilter !== undefined){
    transactionsToFilter.filter((transaction)=>{
        let formatDate = new Date(transaction.createdAt).toLocaleDateString('pt-BR');
        let formatType = () => {
          if(transaction.type === 'reserve'){
            transactions.valueReserve.push(transaction.amount)
            return "reserva"
          }else if(transaction.type === 'debit'){
            transactions.valueDebit.push(transaction.amount)
            return "débito"
          }else if(transaction.type === 'credit'){
            transactions.valueCredit.push(transaction.amount)
            return "crédito"
          }
        }
        transactions.type.push(formatType())
        transactions.date.push(formatDate)
        transactions.description.push(transaction.description)
        transactions.totalExpended += transaction.amount
      return true
    })
  }
  function transformInList(array){
      if(array.length === 0){
        return "<h1>Sem demandas com este status</h1>"
      }
      let html = "<ul class='modal-list'>";
      array.forEach((item,counter)=>{
        html += `
            <li>
                <a href="/dashboard/serviços/detalhes/${item._id}" target="_blank">
                <p>
                    Código: <strong>#000${item.code}</strong> 
                    <br/>
                    <br/>
                    Descrição: <strong>${item.fullDescription}</strong> 
                    <br/>
                    <br/>
                    Status: <strong> ${item.statuses} </strong>
                </p>
                </a>
            </li>
        `;
      })
      html += "</ul>";
      return html;
  }


  const { isOpen, openModal, closeModal, params: modalParams } = useModal();

  // Verificar se há erros nas queries
  const hasErrors = demandsError || documentsError || walletError || subscriptionError

  if(loadingBonuzSub){
    return (
      <div className="h-100 justify-content-center align-items-center d-flex">
        <Spinner color="primary" />
      </div>
    )
  }

  // Mostrar mensagem de erro se houver problemas nas queries
  if(hasErrors && !demandsData && !documentsData && !walletData){
    return (
      <div id="panel">
        <div style={{ 
          padding: '2rem', 
          textAlign: 'center',
          backgroundColor: 'var(--card-bg)',
          borderRadius: '12px',
          border: '1px solid var(--card-border)'
        }}>
          <AlertCircle size={48} style={{ color: '#fd4f5d', marginBottom: '1rem' }} />
          <h2 style={{ color: 'var(--text-color)', marginBottom: '1rem' }}>
            Erro ao carregar dados
          </h2>
          <p style={{ color: 'var(--text-color)', opacity: 0.8 }}>
            Ocorreu um erro ao carregar as informações do painel. 
            Por favor, tente recarregar a página ou entre em contato com o suporte se o problema persistir.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div id="panel">
      <>
        <Modal open={isOpen} onClose={closeModal} header={<h3>{(modalParams || {}).title}</h3>}>
          {
            <Markup content={(modalParams || {}).content}/>
          }
        </Modal>
      </>
      <div id="demands-statistics">
        <h1>Estatísticas</h1>
        <h2>Demandas</h2>
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 300px' }}>
            <ModernCard
              title="Pendências"
              count={loading ? '...' : demands.clientPendencices.concat(demands.waitingApprovalDemands,demands.waitingEstimateApprovalDemands,demands.draftDemands,demands.inReviewDemands).length}
              bgColor="#fd4f5d"
              textColor="#fff"
              accentColor="#fd4f5d"
              icon={<AlertCircle size={20} />}
              onClick={() => openModal({ title:'Demandas pendentes',content:transformInList(demands.clientPendencices.concat(demands.waitingApprovalDemands,demands.waitingEstimateApprovalDemands,demands.draftDemands,demands.inReviewDemands))})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 400px', maxWidth: '100%' }}>
            <Typography style={{textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em', marginBottom: '0.75rem'}} fontWeight="600" m={0}>
              Gráfico geral de demandas
            </Typography>
            <div id="chart">
              <ModernChart
                type="Bar"
                labels={demands.statuses}
                labelTitle="Tipos de demandas solicitadas"
                dataValues={[
                  demands.pendingDemands.length,
                  demands.inProgressDemands.length,
                  demands.standbyDemands.length,
                  demands.waitingApprovalDemands.length,
                  demands.inEstimatingDemands.length,
                  demands.draftDemands.length,
                  demands.demandSentDemands.length,
                  demands.inReviewDemands.length,
                  demands.doneDemands.length,
                  demands.canceledDemands.length,
                  demands.waitingEstimateApprovalDemands.length,
                  demands.waitingLawyerAcceptanceDemands.length
                ]}
              />
            </div>
          </Box>
        </Flex>
        <Typography style={{textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em', marginTop: '2rem', marginBottom: '1rem'}} fontWeight="600" m={0}>
          Demais demandas
        </Typography>
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Pendentes"
              count={loading ? '...' : demands.pendingDemands.length}
              bgColor="#E9D3FB"
              textColor="#350A7C"
              accentColor="#350A7C"
              icon={<Clock size={20} />}
              onClick={() => openModal({ title:'Demandas pendentes',content:transformInList(demands.pendingDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Em Progresso"
              count={loading ? '...' : demands.inProgressDemands.length}
              bgColor="#D6DAFF"
              textColor="#5A67DF"
              accentColor="#5A67DF"
              icon={<PlayCircle size={20} />}
              onClick={() => openModal({ title:'Demandas em progresso',content:transformInList(demands.inProgressDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Stand-by"
              count={loading ? '...' : demands.standbyDemands.length}
              bgColor="#FFF9D7"
              textColor="#F4C51F"
              accentColor="#F4C51F"
              icon={<PauseCircle size={20} />}
              onClick={() => openModal({ title:'Demandas em standby',content:transformInList(demands.standbyDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Aguardando Aprovação"
              count={loading ? '...' : demands.waitingApprovalDemands.length}
              bgColor="#DCDCDC"
              textColor="#5A5A5A"
              accentColor="#5A5A5A"
              icon={<FileCheck size={20} />}
              onClick={() => openModal({ title:'Demandas aguardando Aprovação',content:transformInList(demands.waitingApprovalDemands)})}
              loading={loading}
            />
          </Box>
        </Flex>
        {/*Segunda linha*/}
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Aguardando Orçamento"
              count={loading ? '...' : demands.inEstimatingDemands.length}
              bgColor="#FFF6D7"
              textColor="#F0BA06"
              accentColor="#F0BA06"
              icon={<DollarSign size={20} />}
              onClick={() => openModal({ title:'Demandas em Orçamento',content:transformInList(demands.inEstimatingDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Pendentes de Informação"
              count={loading ? '...' : demands.draftDemands.length}
              bgColor="#FFE7D6"
              textColor="#FF6007"
              accentColor="#FF6007"
              icon={<FileQuestion size={20} />}
              onClick={() => openModal({ title:'Demandas pendentes de informação',content:transformInList(demands.draftDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Demanda Enviada"
              count={loading ? '...' : demands.demandSentDemands.length}
              bgColor="#D3FBE5"
              textColor="#3AC59B"
              accentColor="#3AC59B"
              icon={<Send size={20} />}
              onClick={() => openModal({ title:'Demandas enviadas',content:transformInList(demands.demandSentDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Aguardando revisão"
              count={loading ? '...' : demands.inReviewDemands.length}
              bgColor="#FBEDD3"
              textColor="#68480A"
              accentColor="#68480A"
              icon={<Eye size={20} />}
              onClick={() => openModal({ title:'Demandas aguardando revisão',content:transformInList(demands.inReviewDemands)})}
              loading={loading}
            />
          </Box>
        </Flex>
        {/*Terceira linha*/}
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Canceladas"
              count={loading ? '...' : demands.canceledDemands.length}
              bgColor="#F8D0D0"
              textColor="#C31E1E"
              accentColor="#C31E1E"
              icon={<XCircle size={20} />}
              onClick={() => openModal({ title:'Demandas canceladas',content:transformInList(demands.canceledDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Concluídas"
              count={loading ? '...' : demands.doneDemands.length}
              bgColor="#D6FBD3"
              textColor="#49A96A"
              accentColor="#49A96A"
              icon={<CheckCircle2 size={20} />}
              onClick={() => openModal({ title:'Demandas concluídas',content:transformInList(demands.doneDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Aguardando Aprovação de Orçamento"
              count={loading ? '...' : demands.waitingEstimateApprovalDemands.length}
              bgColor="#FFD7F4"
              textColor="#D4169F"
              accentColor="#D4169F"
              icon={<FileCheck size={20} />}
              onClick={() => openModal({ title:'Demandas Aprovação de Orçamento',content:transformInList(demands.waitingEstimateApprovalDemands)})}
              loading={loading}
            />
          </Box>
          <Box mb={2} style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <ModernCard
              title="Aguardando Aceite do Advogado"
              count={loading ? '...' : demands.waitingLawyerAcceptanceDemands.length}
              bgColor="#FFD7F4"
              textColor="#D4169F"
              accentColor="#D4169F"
              icon={<FileText size={20} />}
              onClick={() => openModal({ title:'Demandas Aprovação do Advogado',content:transformInList(demands.waitingLawyerAcceptanceDemands)})}
              loading={loading}
            />
          </Box>
        </Flex>        
      </div>
      <div id="documents-statistics">
        <h2>Documentos</h2>
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 300px' }}>
            <Typography style={{textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em', marginBottom: '0.75rem'}} fontWeight="600" m={0}>
              Tipos de documentos
            </Typography>
            <div id="docs-list">
              <Box mr={4} ml={0} my={3} width={[1]}>
                <ul className="dash-list">
                {documents.folderNames.length > 0 && (
                  documents.folderNames.map((item, key) => {
                    return (
                      <li key={key}>
                        <a href={`/dashboard/documentos/${documents.folderIds[key]}/Contratos`} target="_blank" rel="noopener noreferrer">
                          {item} : {documents.numberOfDocsInFolders[key]}
                        </a>
                      </li>
                    )
                  })
                )}
                </ul>
              </Box>
            </div>
          </Box>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 300px' }}>
            <Typography style={{textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em', marginBottom: '0.75rem'}} fontWeight="600" m={0}>
              Gráfico geral de documentos
            </Typography>
            <div id="dognohut">
              <ModernChart
                type="Dognhut"
                labels={documents.folderNames}
                dataValues={documents.numberOfDocsInFolders}
              />
            </div>
          </Box>
        </Flex>
      </div>
      {bonuzActive ? (
      <div id="wallets-statistics">
        <h2>Carteira</h2>
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start" style={{ gap: '1.5rem' }}>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 400px' }}>
            <div id="line">
              <ModernChart
                type="Line"
                labels={transactions.date}
                dataValues={[transactions.valueReserve,transactions.valueCredit,transactions.valueDebit]}
              />
            </div>
          </Box>
          <Box mb={2} style={{ minWidth: '280px', flex: '1 1 300px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
              <button className={`refetchWallet ${period === 'last_30_days' ? 'active' : ''}`} onClick={() => {
                changePeriod('last_30_days')
                refetchMyStatements()
              }}>30 DIAS</button>
              <button className={`refetchWallet ${period === 'last_6_months' ? 'active' : ''}`} onClick={() => {
                changePeriod('last_6_months')
                refetchMyStatements()
              }}>6 MESES</button>
              <button className={`refetchWallet ${period === 'last_1_year' ? 'active' : ''}`} onClick={() => {
                changePeriod('last_1_year')
                refetchMyStatements()
              }}>1 ANO</button>
            </div>
            <ModernCard
              title="Total investido"
              count={loading ? '...' : `${transactions.totalExpended} BNZ`}
              bgColor="#009900"
              textColor="#fff"
              accentColor="#009900"
              icon={<Wallet size={20} />}
              loading={loading}
            />
          </Box>
        </Flex>
        <Typography style={{textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.05em', marginTop: '2rem', marginBottom: '1rem'}} fontWeight="600" m={0}>
          Detalhes das transações
        </Typography>
        <Flex flexWrap="wrap" justifyContent="flex-start" width={1} mt={2} alignItems="flex-start">
          <Box mb={1} style={{ width: '100%', maxWidth: '600px' }}>
            <ul className="dash-list">
              {transactions.description.length > 0 && (
                transactions.description.map((item, key) => {
                   return (
                    <li key={key}>
                      {item}
                    </li>
                  )
                })
              )}
            </ul>
          </Box>
        </Flex>
      </div>
        ) : null}
    </div>
  )
}

export default ClientDemandsPanel
